import { render } from "./MessageTextFormDialog.vue?vue&type=template&id=6836642a&scoped=true"
import script from "./MessageTextFormDialog.vue?vue&type=script&lang=js"
export * from "./MessageTextFormDialog.vue?vue&type=script&lang=js"

import "./MessageTextFormDialog.vue?vue&type=style&index=0&id=6836642a&scoped=true&lang=css"

import exportComponent from "/Users/francois/WebstormProjects/crema-manager-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6836642a"]])

export default __exports__